export function getRoutes(basePath) {
  return {
    home: basePath,
    browse: `${basePath}browse/`,
    watchLater: `${basePath}watch-later/`,
    continueWatching: `${basePath}continue-watching/`,
    search: `${basePath}search/`,
    filter: `${basePath}filter/`,
    card: `${basePath}:name/`
  };
}
